<template>
  <div>
      <SaleDetail title="Sales Quotation" type="SQ"></SaleDetail>
  </div>
</template>

// <script>
import SaleDetail from './details.vue'
export default {
   components: { SaleDetail },
}
</script>

<style>

</style>